import React, { useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { useUser } from 'context/user/User';
import WaiterPage from 'modules/restaurant/waiter/WaiterPage';
import TabProvider from 'context/restaurant/TabContext';
import CartProvider from 'context/restaurant/CartContext';
import paths from 'routes/paths';

export default function WaiterApp() {
    const { slug } = useParams();
    const { user, setUser } = useUser();

    const waiterToken = sessionStorage.getItem('otp_token');
    const waiterUserRaw = sessionStorage.getItem('otp_user');
    const waiterUser = waiterUserRaw ? JSON.parse(waiterUserRaw) : null;

    // Hydrate UserContext from otp_user so WaiterPage works unchanged
    useEffect(() => {
        if (waiterUser && !user) {
            setUser(waiterUser);
        }
    }, []);

    if (!waiterToken || !waiterUser) {
        return <Navigate to={paths.otp.login} replace />;
    }

    // Validate slug matches this waiter's establishment
    const userSlug = waiterUser?.establishments?.[0]?.slug;
    if (userSlug && userSlug !== slug) {
        return <Navigate to={`/${userSlug}/garcom`} replace />;
    }

    return (
        <TabProvider>
            <CartProvider>
                <WaiterPage />
            </CartProvider>
        </TabProvider>
    );
}
